import type { IconSvgObject } from './types';

const BoldIcon: IconSvgObject = [
  ["path", { d: "M13 4H7C6.44772 4 6 4.44772 6 5V12H13C15.2091 12 17 10.2091 17 8C17 5.79086 15.2091 4 13 4Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M14 12H6V19C6 19.5523 6.44772 20 7 20H14C16.2091 20 18 18.2091 18 16C18 13.7909 16.2091 12 14 12Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default BoldIcon;
